import core from './core'
import kansas from './kansas'
import rpcService from './rpcService'
import WebSocketLiveService from './webSocketLiveService'
import personalization from './personalization'

export default {
  core,
  kansas,
  rpcService,
  personalization,
  WebSocketLiveService
}



// WEBPACK FOOTER //
// ./src/library/index.js